import React from "react";

function TabellaOrariAdulti() {
    return(
        <div className="table-container">
            <table className="table text-center m-auto" style={{width: "90%", maxWidth: "50em"}}>
                <thead>
                <tr>
                    <th className="" scope="col" style={{width: "20%" }}>Lun</th>
                    <th className="" scope="col" style={{width: "20%" }}>Mar</th>
                    <th className="" scope="col" style={{width: "20%" }}>Mer</th>
                    <th className="" scope="col" style={{width: "20%" }}>Gio</th>
                    <th className="" scope="col" style={{width: "20%" }}>Ven</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th colSpan={5}  scope="" >Mattino - pomeriggio </th>
                </tr>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell">9:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 10:00</td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell">9:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 10:00</td>
                </tr>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell">10:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 10:45</td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell">10:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 10:45</td>
                </tr>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell">10:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 11:30
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell">10:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 11:30
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell"></td>
                    <td className="data-cell">12:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 13:30
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td className="data-cell"></td>
                    <td className="data-cell"></td>
                    <td className="data-cell">12:45 <br className="d-sm-none"/> - <br className="d-sm-none"/> 13:30
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell">16:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:00</td>
                    <td className="data-cell">16:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:00
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td className="data-cell"></td>
                    <td className="data-cell">16:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:00</td>
                    <td className="data-cell">16:15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 17:00
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                </tr>
                <tr>
                    <th colSpan={5}  scope="" >Sera</th>
                </tr>
                <tr>
                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                    <td className="data-cell">19.15 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:00</td>
                </tr>
                <tr>
                    <td className="data-cell">20:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:45
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td className="data-cell">20:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:45
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td/>
                    <td className="data-cell">20:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:45
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                    <td className="data-cell">20:00 <br className="d-sm-none"/> - <br className="d-sm-none"/> 20:45
                        <br/>
                        <div style={{fontSize: "0.8em"}}>solo vasca grande</div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default TabellaOrariAdulti